<div>
  <div class="d-flex justify-content-center">
    <div class="col-md-8">
      <h1 jhiTranslate="activate.title">Activation</h1>
      @if (success()) {
        <div class="alert alert-success">
          <span><strong>Supplier Added Successfully</strong></span>
        </div>
      }
      @if (error()) {
        <div class="alert alert-danger" jhiTranslate="activate.messages.error">
          <strong>Your user could not be activated.</strong> Please use the registration form to sign up.
        </div>
      }
    </div>
  </div>
</div>
